import { useApp } from 'contexts/app';
import { useHistory } from 'react-router-dom';
import { Button, Stack, Text } from 'shell/components';

const FormativeFeedback = () => {
    const { currentAssignmentId } = useApp();
    const history = useHistory();

    const handleClick = () => {
        const params = new URLSearchParams({ type: 'formative' });
        history.push(`/assignments/${currentAssignmentId}/submissions?${params.toString()}`);
    };

    return (
        <Stack alignItems={'flex-start'} spacing={2}>
            <Text variant={'sh2'} weight={'semibold'}>
                Formative Feedback for Student Insights
            </Text>
            <Text color={'light'}>
                See how students refine their drafts and how the AI you’ve trained helps them improve their assignments.
            </Text>
            <Button variant={'borderless'} onClick={handleClick}>
                View Insights
            </Button>
        </Stack>
    );
};

export default FormativeFeedback;
